import type { Value } from "../generated-proto/pb_schema/common/value";
import type { LensCoreConfig } from "../lens-core-module/generated-types";

export function toLensCoreConfigValue(value: Value): LensCoreConfig["value"] | undefined {
    if (value.stringValue) return { stringValue: value.stringValue };
    if (value.boolValue) return { boolValue: value.boolValue };
    if (value.intValue) return { intValue: value.intValue };
    if (value.longValue) return { longValue: Number(value.longValue) };
    if (value.floatValue) return { floatValue: value.floatValue };
    if (value.anyValue) {
        return { anyValue: { typeUrl: value.anyValue.typeUrl, value: value.anyValue.value } };
    }
    return undefined;
}
